var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { colors } from '../../styles';
var OpenHint = function (_a) {
    var _b = _a.color, color = _b === void 0 ? colors.primary : _b, props = __rest(_a, ["color"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "22", height: "22" }, props),
        React.createElement("defs", null,
            React.createElement("circle", { id: "A", cx: "11", cy: "11", r: "11", fill: color }),
            React.createElement("filter", { x: "-34.1%", y: "-34.1%", width: "168.2%", height: "168.2%", id: "B" },
                React.createElement("feOffset", { in: "SourceAlpha" }),
                React.createElement("feGaussianBlur", { stdDeviation: "2.5" }),
                React.createElement("feColorMatrix", { values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.188066816 0" }))),
        React.createElement("g", { fillRule: "evenodd" },
            React.createElement("use", { fill: "#000", filter: "url(#B)", xlinkHref: "#A" }),
            React.createElement("use", { fill: "#153255", xlinkHref: "#A" }),
            React.createElement("path", { d: "M12.203 7.28c1.136 0 2.096-.624 2.464-1.632.352-.96-.16-1.648-1.264-1.648s-2.128.688-2.48 1.648c-.336.944.176 1.632 1.28 1.632zm-3.728 6.512l.15-.468 1.226-3.436c.08-.24.048-.512-.112-.496-.208 0-.848.288-1.584 1.008-.064.064-.192-.016-.144-.096l.612-.695c.685-.771 1.396-1.504 2.22-1.849.864-.368 2.72.736 2.128 2.576l-1.376 4.08c-.08.224-.016.352.128.352.352 0 1.088-.496 1.824-1.296.112-.096.192.016.128.112l-.388.463c-.962 1.126-1.854 2.005-2.348 2.273-1.152.624-2.992-.832-2.464-2.528z", fill: "#fff", fillRule: "nonzero" }))));
};
export default OpenHint;
//# sourceMappingURL=OpenHint.js.map